export default __webpack_public_path__ + "static/media/yaara-kalmanovich.6bfa4d1f.png";